module.exports = __webpack_public_path__ + "static/media/notebook-dynamic-premium.6c230be2.png";